import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select, {selectType} from 'Components/Select';
import { ACTION } from 'constants/index';

export default class Row extends React.Component {
  _selectAction = actionKey => {
    const { component, performActionFunction, updateComponentListEntry } = this.props;
    performActionFunction(actionKey, component.id).then(updatedData =>
      updateComponentListEntry(component, updatedData)
    );
  };

  _getStatusColor = () => {
    const { component } = this.props;

    if (component && component.applicationStatus) {
      return `list-scene__status-label_${component.applicationStatus.toString().toLowerCase()}`;
    }
    return '';
  };

  _getTextColourStyle = key => {
    const { sortedBy } = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  _getComponentReadableStatus = () => {
    const { component } = this.props;

    if (component && component.applicationStatus) {
      return component.applicationStatus[0].toUpperCase() + component.applicationStatus.slice(1).toLowerCase();
    }

    return '';
  };

  _getBackgroundColourStyle = () => {
    const { isOdd } = this.props;

    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  render() {
    const { component, availableActionsList } = this.props;

    return (
      <div
        id={`componentListRowID${component.id}`}
        className={`list-scene__table-row ${this._getBackgroundColourStyle()}`}
        onClick={() => {
          this._selectAction(ACTION.DETAILS);
        }}
      >
        <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

        <div
          id='componentIDField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('id')} _width_pc_8`}
        >
          {component.id}
        </div>

        <div
          id='componentSubmissionDateField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('submissionDate')} _width_pc_8`}
        >
          {moment(component.submissionDate).format('MM/DD/YYYY')}
        </div>

        <div
          id='componentTypeField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('componentType')} _width_pc_12`}
        >
          {component.componentType.componentTypeName}
        </div>

        <div
          id='componentDescriptionField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('description')} list-scene__table-row-element_place_filler`}
        >
          {component.description}
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
          <div
            id='componentStatusField'
            className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle(
              'applicationStatus'
            )}`}
          >
            {this._getComponentReadableStatus()}
          </div>
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
          <Select
            placeholder='Actions'
            withoutSearch
            multiSelect
            selectionList={availableActionsList}
            handleSelect={this._selectAction}
            type={selectType.listActions}
          />
        </div>

        <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
      </div>
    );
  }
}

Row.propTypes = {
  component: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
  zIndex: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/List/Row.jsx